export enum CheckrRequestStatusIds {
  PENDING = 1,
  COMPLETED = 2,
  EXPIRED = 3,
}
